import React, { useEffect, useState } from "react";
import PageTitle from "../../../jsx/layouts/PageTitle";

const initialForm = {
  top_text: "",
  heading: "",
  highlight: "",
  description: "",
  button_text: "",
  button_link: "",
  experience_number: "",
  experience_text: "",
  count1: "",
  count1_text: "",
  count2: "",
  count2_text: "",
  count3: "",
  count3_text: "",
};

const HeroDashboard = () => {
  const [heroData, setHeroData] = useState(null);
  const [form, setForm] = useState(initialForm);
  const [heroImage, setHeroImage] = useState(null);
  const [editingId, setEditingId] = useState(null);

  // ✅ success / error message states
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState(""); // success / error

  useEffect(() => {
    fetchHero();
  }, []);

  const fetchHero = async () => {
    try {
      const res = await fetch("https://admin.drgargevascular.com/backend/hero");
      const data = await res.json();

      if (data && data.id) {
        setHeroData(data);
        setEditingId(data.id);

        setForm({
          top_text: data.top_text || "",
          heading: data.heading || "",
          highlight: data.highlight || "",
          description: data.description || "",
          button_text: data.button_text || "",
          button_link: data.button_link || "",
          experience_number: data.experience_number || "",
          experience_text: data.experience_text || "",
          count1: data.count1 || "",
          count1_text: data.count1_text || "",
          count2: data.count2 || "",
          count2_text: data.count2_text || "",
          count3: data.count3 || "",
          count3_text: data.count3_text || "",
        });
      } else {
        setHeroData(null);
        setEditingId(null);
        setForm(initialForm);
      }
    } catch (error) {
      console.error("Error fetching hero:", error);
      setHeroData(null);
    }
  };

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  const handleFileChange = (e) => {
    setHeroImage(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();

    Object.keys(form).forEach((key) => {
      formData.append(key, form[key]);
    });

    if (heroImage) {
      formData.append("hero_image", heroImage);
    }

    try {
      const url = editingId
        ? `https://admin.drgargevascular.com/backend/hero/${editingId}`
        : "https://admin.drgargevascular.com/backend/hero";

      const method = editingId ? "PUT" : "POST";

      const res = await fetch(url, {
        method,
        body: formData,
      });

      if (!res.ok) throw new Error("Failed request");

      setMessage(
        editingId
          ? "Hero banner updated successfully!"
          : "Hero banner added successfully!"
      );
      setMessageType("success");

      fetchHero();

      setTimeout(() => {
        setMessage("");
        setMessageType("");
      }, 4000);
    } catch (error) {
      console.error("Error saving hero:", error);

      setMessage("Something went wrong. Please try again.");
      setMessageType("error");

      setTimeout(() => {
        setMessage("");
        setMessageType("");
      }, 4000);
    }
  };

  const handleReset = () => {
    setForm(initialForm);
    setHeroImage(null);
    setEditingId(null);
    setHeroData(null);
    setMessage("");
    setMessageType("");
  };

  return (
    <>
      <PageTitle activeMenu="Hero Banner" motherMenu="Dashboard" />

      <div className="row">
        {/* ================= FORM ================= */}
        <div className="col-xl-12">
          <div className="card shadow-sm border-0">
            <div className="card-header d-flex justify-content-between align-items-center bg-white border-bottom">
              <div>
                <h4 className="mb-0 fw-bold">
                  {editingId ? "Edit Home Hero Banner" : "Add Home Hero Banner"}
                </h4>
                <small className="text-muted">
                  Manage your homepage hero section dynamically
                </small>
              </div>

              {editingId && (
                <button
                  type="button"
                  className="btn btn-outline-secondary btn-sm"
                  onClick={handleReset}
                >
                  Reset Form
                </button>
              )}
            </div>

            <div className="card-body">
              <form onSubmit={handleSubmit}>
                <div className="row">
                  {/* TOP TEXT */}
                  <div className="col-md-4 mb-3">
                    <label className="form-label fw-bold">Top Text</label>
                    <input
                      type="text"
                      name="top_text"
                      className="form-control"
                      placeholder="e.g. Advanced Vascular Care"
                      value={form.top_text}
                      onChange={handleChange}
                    />
                  </div>

                  {/* HEADING */}
                  <div className="col-md-4 mb-3">
                    <label className="form-label fw-bold">Main Heading</label>
                    <input
                      type="text"
                      name="heading"
                      className="form-control"
                      placeholder="e.g. Expert"
                      value={form.heading}
                      onChange={handleChange}
                    />
                  </div>

                  {/* HIGHLIGHT */}
                  <div className="col-md-4 mb-3">
                    <label className="form-label fw-bold">Highlight Text</label>
                    <input
                      type="text"
                      name="highlight"
                      className="form-control"
                      placeholder="e.g. Vascular Solutions"
                      value={form.highlight}
                      onChange={handleChange}
                    />
                  </div>

                  {/* DESCRIPTION */}
                  <div className="col-md-12 mb-3">
                    <label className="form-label fw-bold">Description</label>
                    <textarea
                      name="description"
                      className="form-control"
                      rows="4"
                      placeholder="Enter hero description"
                      value={form.description}
                      onChange={handleChange}
                    ></textarea>
                  </div>

                  {/* BUTTON TEXT */}
                  <div className="col-md-6 mb-3">
                    <label className="form-label fw-bold">Button Text</label>
                    <input
                      type="text"
                      name="button_text"
                      className="form-control"
                      placeholder="e.g. Learn More"
                      value={form.button_text}
                      onChange={handleChange}
                    />
                  </div>

                  {/* BUTTON LINK */}
                  <div className="col-md-6 mb-3">
                    <label className="form-label fw-bold">Button Link</label>
                    <input
                      type="text"
                      name="button_link"
                      className="form-control"
                      placeholder="e.g. /about"
                      value={form.button_link}
                      onChange={handleChange}
                    />
                  </div>

                  {/* EXPERIENCE */}
                  <div className="col-md-6 mb-3">
                    <label className="form-label fw-bold">
                      Experience Number
                    </label>
                    <input
                      type="text"
                      name="experience_number"
                      className="form-control"
                      placeholder="e.g. 10+"
                      value={form.experience_number}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="col-md-6 mb-3">
                    <label className="form-label fw-bold">
                      Experience Text
                    </label>
                    <input
                      type="text"
                      name="experience_text"
                      className="form-control"
                      placeholder="e.g. Years Experience"
                      value={form.experience_text}
                      onChange={handleChange}
                    />
                  </div>

                  {/* COUNTERS */}
                  <div className="col-12 mt-3 mb-2">
                    <h5 className="border-bottom pb-2 fw-bold">
                      Counter Section
                    </h5>
                  </div>

                  {/* COUNT 1 */}
                  <div className="col-md-2 mb-3">
                    <label className="form-label fw-bold">Count 1</label>
                    <input
                      type="number"
                      name="count1"
                      className="form-control"
                      value={form.count1}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-md-2 mb-3">
                    <label className="form-label fw-bold">Count 1 Text</label>
                    <input
                      type="text"
                      name="count1_text"
                      className="form-control"
                      value={form.count1_text}
                      onChange={handleChange}
                    />
                  </div>

                  {/* COUNT 2 */}
                  <div className="col-md-2 mb-3">
                    <label className="form-label fw-bold">Count 2</label>
                    <input
                      type="number"
                      name="count2"
                      className="form-control"
                      value={form.count2}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-md-2 mb-3">
                    <label className="form-label fw-bold">Count 2 Text</label>
                    <input
                      type="text"
                      name="count2_text"
                      className="form-control"
                      value={form.count2_text}
                      onChange={handleChange}
                    />
                  </div>

                  {/* COUNT 3 */}
                  <div className="col-md-2 mb-3">
                    <label className="form-label fw-bold">Count 3</label>
                    <input
                      type="number"
                      name="count3"
                      className="form-control"
                      value={form.count3}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-md-2 mb-3">
                    <label className="form-label fw-bold">Count 3 Text</label>
                    <input
                      type="text"
                      name="count3_text"
                      className="form-control"
                      value={form.count3_text}
                      onChange={handleChange}
                    />
                  </div>

                  {/* HERO IMAGE */}
                  <div className="col-md-12 mt-3 mb-3">
                    <label className="form-label fw-bold">Hero Image</label>
                    <input
                      type="file"
                      name="hero_image"
                      className="form-control"
                      onChange={handleFileChange}
                    />
                  </div>

                  {/* ✅ MESSAGE BELOW FORM */}
                  {message && (
                    <div className="col-md-12">
                      <div
                        className={`alert ${
                          messageType === "success"
                            ? "alert-success"
                            : "alert-danger"
                        }`}
                        style={{
                          fontSize: "14px",
                          borderRadius: "8px",
                          padding: "10px 15px",
                        }}
                      >
                        {message}
                      </div>
                    </div>
                  )}

                  {/* BUTTON */}
                  <div className="col-md-12 mt-2">
                    <button className="btn btn-primary me-2 px-4">
                      {editingId ? "Update Hero Banner" : "Add Hero Banner"}
                    </button>

                    <button
                      type="button"
                      className="btn btn-outline-secondary"
                      onClick={handleReset}
                    >
                      Clear
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>

        {/* ================= PREVIEW CARD ================= */}
        <div className="col-xl-12 mt-4">
          <div className="card shadow-sm border-0">
            <div className="card-header bg-white border-bottom">
              <h4 className="mb-0 fw-bold">Current Hero Preview</h4>
            </div>

            <div className="card-body">
              {heroData ? (
                <div className="row align-items-center">
                  {/* LEFT CONTENT */}
                  <div className="col-lg-7">
                    <span
                      className="d-inline-block mb-3 px-3 py-2 rounded-pill"
                      style={{
                        background: "#fef2f4",
                        color: "#d63384",
                        fontWeight: "600",
                        fontSize: "14px",
                      }}
                    >
                      <i className="fa-solid fa-heart me-2"></i>
                      {heroData.top_text}
                    </span>

                    <h1
                      style={{
                        fontSize: "42px",
                        fontWeight: "800",
                        lineHeight: "1.2",
                      }}
                    >
                      {heroData.heading}{" "}
                      <span style={{ color: "#d63384" }}>
                        {heroData.highlight}
                      </span>
                    </h1>

                    <p
                      className="text-muted mt-3"
                      style={{ fontSize: "16px", maxWidth: "700px" }}
                    >
                      {heroData.description}
                    </p>

                    <div className="d-flex align-items-center gap-4 mt-4 flex-wrap">
                      <button className="btn btn-primary px-4 py-2">
                        {heroData.button_text || "Learn More"}
                      </button>

                      <div>
                        <h5 className="mb-0 fw-bold">
                          {heroData.experience_number}
                        </h5>
                        <small className="text-muted">
                          {heroData.experience_text}
                        </small>
                      </div>
                    </div>

                    <div className="row mt-4 g-3">
                      <div className="col-md-4">
                        <div className="border rounded p-3 text-center">
                          <h3 className="fw-bold mb-1">{heroData.count1}+</h3>
                          <small className="text-muted">
                            {heroData.count1_text}
                          </small>
                        </div>
                      </div>

                      <div className="col-md-4">
                        <div className="border rounded p-3 text-center">
                          <h3 className="fw-bold mb-1">{heroData.count2}+</h3>
                          <small className="text-muted">
                            {heroData.count2_text}
                          </small>
                        </div>
                      </div>

                      <div className="col-md-4">
                        <div className="border rounded p-3 text-center">
                          <h3 className="fw-bold mb-1">{heroData.count3}+</h3>
                          <small className="text-muted">
                            {heroData.count3_text}
                          </small>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* RIGHT IMAGE */}
                  <div className="col-lg-5 mt-4 mt-lg-0">
                    <div
                      className="border rounded overflow-hidden"
                      style={{
                        minHeight: "380px",
                        background: "#f8f9fa",
                      }}
                    >
                      {heroData.hero_image ? (
                        <img
                          src={`https://admin.drgargevascular.com/backend${heroData.hero_image}`}
                          alt="Hero"
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            minHeight: "380px",
                          }}
                        />
                      ) : (
                        <div
                          className="d-flex align-items-center justify-content-center h-100 text-muted"
                          style={{ minHeight: "380px" }}
                        >
                          No Hero Image Uploaded
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              ) : (
                <div className="text-center py-5 text-muted">
                  No hero banner data found. Add one above.
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HeroDashboard;